import { PermissionsEdiFeatures, PermissionsGroupName } from '@/constants/permissions';
import { onHandRouteOption } from '@/router/routes/exports/exports.routes';

export const ediRoutes = [
  {
    name: 'EdiDashboard',
    path: 'edi',
    component: () => import('@/layouts/EmptyRouterView.vue'),
    redirect: { name: 'EdiImports' },
    meta: {
      pageTitle: 'EDI Dashboard',
      permission: PermissionsGroupName.EDI,
    },
    children: [
      {
        name: 'EdiImports',
        path: 'imports',
        component: () => import('@/layouts/EmptyRouterView.vue'),
        redirect: { name: 'ImportsOcean' },
        meta: {
          pageTitle: 'EDI Dashboard',
          permission: PermissionsEdiFeatures.IMPORTS,
        },
        children: [
          {
            name: 'ImportsOcean',
            path: 'ocean-imports',
            component: () => import('@/views/edi/EDIView.vue'),
            meta: {
              pageTitle: 'EDI Ocean Imports',
              permission: PermissionsEdiFeatures.IMPORTS,
            },
          },
          {
            name: 'ImportsAir',
            path: 'air-imports',
            component: () => import('@/views/edi/EdiAirImportsView.vue'),
            meta: {
              pageTitle: 'EDI Air Imports',
              permission: PermissionsEdiFeatures.IMPORTS,
            },
          },
        ],
      },
      {
        path: 'exports',
        meta: {
          pageTitle: 'Pre Advice Dashboard',
          permission: PermissionsEdiFeatures.IMPORTS,
        },
        component: () => import('@/layouts/EmptyRouterView.vue'),
        children: [
          {
            name: 'EdiExports',
            path: '',
            meta: {
              pageTitle: 'Pre Advice Dashboard',
              permission: PermissionsEdiFeatures.IMPORTS,
            },
            component: () => import('@/views/edi/ExportEdiView.vue'),
          },
          {
            meta: {
              breadcrumb: {
                label: 'Export EDI',
                routeName: 'EdiExports',
              },
            },
            component: () => import('@/layouts/breadcrumb/BreadcrumbLayout.vue'),
            path: '',
            children: [onHandRouteOption('EdiExportsOnHand', ':id')],
          },
        ],
      },
    ],
  },
];
